// services/packages.ts — catálogo de procedimentos e OPMEs (vem do banco, não de listas estáticas)
import { AuthFetch } from "../hooks/useApi";
import { ApiOpmeKit, ApiProcedureKit } from "../types/order.types";

export interface ProcedimentoCatalogo {
  id: number;
  cod_procedimento: string;
  nome: string;
  especialidade: string;
  porte: string | null;
}

export interface Especialidade {
  chave: string;
  nome: string;
}

export interface OpmeCatalogo {
  id: number;
  nome: string;
}

// Uma requisição por especialidade (SearchBar e Checkbox usam a mesma lista).
const procedimentosCache: Record<string, Promise<ProcedimentoCatalogo[]>> = {};
let opmesCache: Promise<OpmeCatalogo[]> | null = null;
let especialidadesCache: Promise<Especialidade[]> | null = null;

export const packagesService = {
  procedimentos: (apiFetch: AuthFetch, especialidade: string): Promise<ProcedimentoCatalogo[]> => {
    procedimentosCache[especialidade] ??= apiFetch<ProcedimentoCatalogo[]>("/packages/procedimentos", {
      method: "POST",
      body: JSON.stringify({ especialidade }),
    }).catch((err) => {
      delete procedimentosCache[especialidade];
      throw err;
    });
    return procedimentosCache[especialidade];
  },

  especialidades: (apiFetch: AuthFetch): Promise<Especialidade[]> => {
    especialidadesCache ??= apiFetch<Especialidade[]>("/packages/especialidades").catch((err) => {
      especialidadesCache = null;
      throw err;
    });
    return especialidadesCache;
  },

  opmes: (apiFetch: AuthFetch): Promise<OpmeCatalogo[]> => {
    opmesCache ??= apiFetch<OpmeCatalogo[]>("/packages/opmes", { method: "POST", body: "{}" }).catch((err) => {
      opmesCache = null;
      throw err;
    });
    return opmesCache;
  },

  // A IA marca com `escolhido` o pacote que combina com o histórico e o laudo.
  procedureKits: (apiFetch: AuthFetch, tipo: "personalizados" | "padronizados", body: object): Promise<ApiProcedureKit[]> =>
    apiFetch<ApiProcedureKit[]>(`/packages/kits_procedimentos_${tipo}`, { method: "POST", body: JSON.stringify(body) }),

  opmeKits: (apiFetch: AuthFetch, tipo: "personalizados" | "padronizados", body: object): Promise<ApiOpmeKit[]> =>
    apiFetch<ApiOpmeKit[]>(`/packages/kits_opmes_${tipo}`, { method: "POST", body: JSON.stringify(body) }),

  // Sem retry de propósito: repetir um POST que deu 5xx pode criar o pacote duas vezes.
  salvarPersonalizado: (apiFetch: AuthFetch, tipo: "opmes" | "procedimentos", body: object): Promise<unknown> =>
    apiFetch(`/packages/salvar_${tipo}_personalizados`, { method: "POST", body: JSON.stringify(body) }),
};
